import React, { useCallback, useState } from 'react';
import MoodleQuizEntry from '../../../../Moodle/Quiz/MoodleQuizEntry';
import MoodleQuizWrapper from '../../../../Moodle/Quiz/MoodleQuizWrapper';
import MoodleQuizResult from '../../../../Moodle/Quiz/MoodleQuizResult';
import MoodleQuizReview from '../../../../Moodle/Quiz/MoodleQuizReview';
import type { MoodleInstance } from '../../../../../../hooks/useMoodleHooks';

type Stage = 'entry' | 'attempt' | 'result' | 'review';

interface Props {
  courseId: string;
  quizId: number;
  instance: MoodleInstance;
}

export default function MoodleQuizRenderer({ courseId, quizId, instance }: Props) {
  const [stage, setStage] = useState<Stage>('entry');
  const [attemptId, setAttemptId] = useState<number | null>(null);

  const handleStartAttempt = useCallback((aid: number) => {
    setAttemptId(aid);
    setStage('attempt');
  }, []);

  const handleAttemptFinished = useCallback((aid: number) => {
    setAttemptId(aid);
    setStage('result');
  }, []);

  const handleContinueToReview = useCallback(() => {
    setStage('review');
  }, []);

  const handleBackToEntry = useCallback(() => {
    setStage('entry');
  }, []);

  return (
    <div style={{ padding: '1.5rem' }}>
      {stage === 'entry' && (
        <MoodleQuizEntry
          courseId={courseId}
          quizId={String(quizId)}
          instance={instance}
          onStartAttempt={handleStartAttempt}
        />
      )}

      {stage === 'attempt' && attemptId != null && (
        <MoodleQuizWrapper
          courseId={courseId}
          quizId={String(quizId)}
          attemptId={String(attemptId)}
          instance={instance}
          onAttemptFinished={handleAttemptFinished}
          onBackToEntry={handleBackToEntry}
        />
      )}

      {stage === 'result' && attemptId != null && (
        <MoodleQuizResult
          courseId={courseId}
          quizId={String(quizId)}
          attemptId={String(attemptId)}
          instance={instance}
          onContinue={handleContinueToReview}
          onBackToEntry={handleBackToEntry}
        />
      )}

      {stage === 'review' && attemptId != null && (
        <MoodleQuizReview
          courseId={String(courseId)}
          quizId={String(quizId)}
          attemptId={String(attemptId)}
          instance={instance}
          onCompleteReview={handleBackToEntry}
        />
      )}
    </div>
  );
}